import tagDialogSelector from './tag-dialog-selector.vue'

tagDialogSelector.install = function (Vue) {
	Vue.component(tagDialogSelector.name, tagDialogSelector);
}

export default tagDialogSelector;

class tagDialogInstance{
	constructor() {
		this.instance = null;
	}
	init() {
		// 初始化实例，挂载dom
		const VueInstance = window.Vue;
		let tagComponent = VueInstance.extend(tagDialogSelector);
		this.instance = new tagComponent({
			el: document.createElement('div'),
		}).$mount();
		document.body.appendChild(this.instance.$el);
	}
	getInstance() {
		// 返回实例
		return this.instance;
	}
	// 外部调用方法
	show(params) {
		return new Promise((resolve, reject) => {
			if (!this.instance) {
				this.init();
			}
			Object.assign(this.instance, {resolve, reject})
			this.instance.show(params);
		})
		
	}
}

export const tagDialogSelectorModal = new tagDialogInstance();
window.tagDialogSelectorModal = tagDialogSelectorModal;